import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["checkAndCompleteTask", "completeTask", "task"];
import { useCallback } from 'react';
import styled from 'styled-components';
import { Button } from 'foundations-components/transitional/components/Button';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { TASKS_AUTO_COMPLETE_WHEN_STARTED } from 'getting-started-shared-tasks/autoCompleteWhenStartedTasks';
import { captureNetworkError } from 'growth-onboarding-reliability/utils/raven';
import DependencyTasksTooltip from './DependencyTasksTooltip';
import { useManualDetectedTaskButton } from '../../../hooks/addonComponents';
import { useTaskLink } from '../../../hooks/hub';
import { useTracker } from '../../../hooks/tracking';
import { useUncompletedDependencyTasks } from '../../../hooks/task';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionButtonWrapper = styled.div.withConfig({
  displayName: "TaskActionButton__ActionButtonWrapper",
  componentId: "v4wlg2-0"
})(["align-self:flex-start !important;"]);
const TaskActionButton = _ref => {
  let {
      checkAndCompleteTask,
      completeTask,
      task
    } = _ref,
    passThroughProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    key,
    id,
    link,
    linkText,
    openLinkInNewTab,
    openLinkInZorse
  } = task;
  const {
    trackTaskInteraction
  } = useTracker();
  const ManualDetectedTaskActionButton = useManualDetectedTaskButton(task.key);
  const {
    handholdingEnabled
  } = task;
  const trackTaskActionClick = useCallback(() => trackTaskInteraction('click task action', key, {
    handholdingEnabled: Boolean(handholdingEnabled)
  }), [handholdingEnabled, key, trackTaskInteraction]);
  const dependencyTasks = useUncompletedDependencyTasks(task.dependentTasks);
  const taskLink = useTaskLink(link, id, task.handholdingEnabled, task.handholdingGroupKeyOverride, task.handholdingSource);
  const onClickHandler = useCallback(() => {
    trackTaskActionClick();
    if (completeTask && TASKS_AUTO_COMPLETE_WHEN_STARTED.includes(key)) {
      completeTask(key).catch(captureNetworkError);
    }
  }, [completeTask, key, trackTaskActionClick]);
  if (!taskLink) {
    return null;
  }
  const buttonProps = Object.assign({
    size: 'small',
    use: 'primary',
    'data-onboarding': 'task-action-button',
    'data-test-id': `task-action-button-${key}`,
    disabled: Boolean(dependencyTasks)
  }, passThroughProps);
  if (openLinkInZorse) {
    return /*#__PURE__*/_jsx(ActionButtonWrapper, {
      children: /*#__PURE__*/_jsx(KnowledgeBaseButton, Object.assign({
        url: taskLink,
        useZorse: true
      }, buttonProps, {
        children: linkText
      }))
    });
  }
  if (ManualDetectedTaskActionButton) {
    return /*#__PURE__*/_jsx(DependencyTasksTooltip, {
      dependencyTasks: dependencyTasks,
      taskKey: key,
      children: /*#__PURE__*/_jsx(ActionButtonWrapper, {
        children: /*#__PURE__*/_jsx(ManualDetectedTaskActionButton, Object.assign({
          checkAndCompleteTask: checkAndCompleteTask
          // @ts-expect-error typing here is tricky, not sure why
          ,
          onClick: trackTaskActionClick,
          task: task
        }, buttonProps, {
          children: linkText
        }))
      })
    });
  }
  return /*#__PURE__*/_jsx(DependencyTasksTooltip, {
    dependencyTasks: dependencyTasks,
    taskKey: key,
    children: /*#__PURE__*/_jsx(ActionButtonWrapper, {
      children: /*#__PURE__*/_jsx(Button, Object.assign({
        external: openLinkInNewTab,
        href: taskLink,
        onClick: onClickHandler
      }, buttonProps, {
        children: linkText
      }))
    })
  });
};
export default TaskActionButton;